import { render, staticRenderFns } from "./Factsheets.vue?vue&type=template&id=2e7ab181&"
import script from "./Factsheets.vue?vue&type=script&lang=js&"
export * from "./Factsheets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports